import React from 'react';

import WpButton, { Variant } from 'Wpds/components/button/WpButton';
import { getHumanizedMeetingTypeFromURL, getMeetingTypeFromURL } from 'Shared/components/MeetingConference/utils';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

type Props = {
  variant?: Variant;
  meetingUrl: string;
};

const DEFAULT_VARIANT = 'secondary';

function JoinMeetingConferenceButton({ variant = DEFAULT_VARIANT, meetingUrl }: Props) {
  const handleClick = () => {
    (window as any).analytics.track('Clicked Join Meeting Conference', {
      conference: getMeetingTypeFromURL(meetingUrl),
    });

    const a = document.createElement('a');
    a.href = meetingUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  };

  return (
    <WpTooltip placement="top">
      <WpTooltipTrigger>
        <WpButton variant={variant} onClick={handleClick}>
          {`Join ${getHumanizedMeetingTypeFromURL(meetingUrl)}`}
        </WpButton>
      </WpTooltipTrigger>
      <WpTooltipContent>The URL for this meeting was found in the connected calendar event</WpTooltipContent>
    </WpTooltip>
  );
}

export default JoinMeetingConferenceButton;
